import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';
import { WarningMessage } from '../../../../components/widgets';

const InsightsErrorBoundary = ({ children }) => {
    const handleError = (error, errorInfo) => {
        console.error('InsightsShelf Error:', error, errorInfo);
    };

    const ErrorFallback = () => (
        <WarningMessage
            showIcon
            message="Something went wrong while loading insights. Please try refreshing or contact support if the issue persists."
        />
    );

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
            {children}
        </ErrorBoundary>
    );
};

InsightsErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};

export default InsightsErrorBoundary;
